import { createContext } from 'react';
import { IRadioVariants, radioVariants } from './radio.variants';

export type RadioContextProps = {
  variant?: keyof typeof radioVariants | (string & {});
  variants?: IRadioVariants;
};

export const RadioContext = createContext<RadioContextProps | null>(null);
